import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { translate } from '@openclassrooms/translations';
import QuestionAnswer from '@mui/icons-material/QuestionAnswer';
import { styled } from '@classify/react-core-components/styles';
import Card from '@classify/react-core-components/Card';
import Narrative from '@classify/react-marketing-components/Narrative';
import { NarrativeMediaContainer, MediaFormats } from '@classify/react-marketing-components/NarrativeMediaContainer';
import Intro from './Intro';
import Quote from './Quote';
import SupportSrc from './images/support.svg';
import AliceSrc from '../IntroTestimonials/images/Alice.png';
const InnerWrapper = styled('div')(({
  theme: {
    spacing
  }
}) => ({
  padding: spacing(3)
}));
const SupportServiceCard = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      border: "none",
      p: 4,
      mt: 10
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <NarrativeMediaContainer format={MediaFormats.isSquare} sx={{
      alignSelf: "center"
    }}><Image src={SupportSrc} alt="Support" /></NarrativeMediaContainer>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Intro title={translate("student_experience.stepper_four.support.keyword")} intro={translate("student_experience.stepper_four.support.text")} icon={QuestionAnswer} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = translate("student_experience.stepper_four.support.quote");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Card sx={t0}><Narrative media={t1}><InnerWrapper>{t2}<Quote variant="service" quote={t3} testimonialPictureSrc={AliceSrc} description={translate("student_experience.stepper_four.support.quote_description")} status={translate("student_experience.stepper_four.support.quote_description2")} /></InnerWrapper></Narrative></Card>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default SupportServiceCard;